import React, { useState, useEffect } from "react";
import { MDBTable, MDBTableBody, MDBTableHead, MDBIcon, MDBBtn } from "mdbreact";
import { Accordion, Item } from 'devextreme-react/accordion';
import DatePicker from "react-datepicker";
import moment from "moment";
import { toast } from "react-toastify";
import * as Excel from "exceljs";
import { saveAs } from "file-saver";
import { useFieldArray } from "react-hook-form";
import MeasurementsItems from "./MeasurementsItems";
import { format } from 'date-fns';
import firebase from "../../../firebase";

const Measurements = (props) => {
    const [dataIndex, setDataIndex] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [idx, setIdx] = useState(null);
    const [insertionDate, setInsertionDate] = useState(null);
    const [removeIndex, setRemoveIndex] = useState(null);
    const control = props.control;
    const register = props.register;
    const [which, setWhich] = useState(null);
    const [editIndex, setEditIndex] = useState(null);

    useEffect(() => {}, [props.reloader, props.appendItem]);

    useEffect(() => {
        setWhich(props.which);
        (which === props.which && props.appendComment !== null && props.appendComment !== undefined) && addComments();
    }, [props.appendComment]);

    const { fields } = useFieldArray({
        control,
        name: `process[${props.nestIndex}].items`
    });

    const { fields: fieldComments, remove: fieldRemoveComments, append: fieldAppendComments } = useFieldArray({
        control,
        name: `process[${props.nestIndex}].fieldComments`,
        key: "insertedDate"
    });

    const { fields: labComments, remove: labRemoveComments, append: labAppendComments } = useFieldArray({
        control,
        name: `process[${props.nestIndex}].labComments`,
        key: "insertedDate"
    });

    const {
        fields: automaticComments,
        remove: automaticRemoveComments,
        append: automaticAppendComments,
    } = useFieldArray({
        control,
        name: `process[${props.nestIndex}].automaticComments`,
        key: "insertedDate"
    });

    useEffect(() => {
        if (removeIndex !== null) {
            handleColumn(removeIndex);
        }
    }, [removeIndex]);

    const startAt = (date) => {
        const parsed = format(date, 'yyyy-MM-dd HH:mm:00.000');
        return new Date(parsed);
    };

    const addComments = async () => {
        let fieldComment = await props.db.collection('measurement').doc(props.getValues(`id`)).collection('process').doc(props.getValues(`process[${props.nestIndex}].id`)).collection(`${props.which}Comments`)
            .where("insertedDate", ">=", startAt(props.appendItem.insertedDate))
            .where("insertedDate", "<", startAt((new Date(props.appendItem.insertedDate)).setMinutes((new Date(props.appendItem.insertedDate)).getMinutes() + 1)))
            .limit(1).get();

        let commentsArray = props.getValues(`process[${props.nestIndex}][${props.which}Comments]`) || [];
        let same = commentsArray.find((z) => z && z.insertedDate && moment(z.id === undefined ? z.insertedDate : (z.insertedDate.toDate ? z.insertedDate.toDate() : z.insertedDate)).isSame(props.appendComment.insertedDate, 'minute'));

        if (fieldComment.docs.length === 0 && same === undefined) {
            switch (props.which) {
                case 'field':
                    fieldAppendComments(props.appendComment);
                    break;
                case 'lab':
                    labAppendComments(props.appendComment);
                    break;
                case 'automatic':
                    automaticAppendComments(props.appendComment);
                    break;
                default:
                    break;
            }
        }
    };

    const whichComments = props.which === 'field' ? fieldComments : (props.which === 'lab' ? labComments : automaticComments);

    function compareDatesDesc(a, b) {
        const dateA = props.dateFormatter(a.insertedDate);
        const dateB = props.dateFormatter(b.insertedDate);
        if (dateA < dateB) return 1;
        if (dateA > dateB) return -1;
        return 0;
    }

    function compareDatesAsc(a, b) {
        const dateA = props.dateFormatter(a.insertedDate);
        const dateB = props.dateFormatter(b.insertedDate);
        if (dateA < dateB) return -1;
        if (dateA > dateB) return 1;
        return 0;
    }

    const commentsArr = props.getValues(`process[${props.nestIndex}][${props.which}Comments`);
    if (Array.isArray(commentsArr)) {
        commentsArr.sort(compareDatesDesc);
    }
    if (Array.isArray(whichComments)) {
        whichComments.sort(compareDatesDesc);
    }

    // Calculate unified unique timestamps across ALL items in this process for exact column alignment
    const getUniqueTimestamps = () => {
        const items = props.getValues(`process[${props.nestIndex}].items`) || [];
        const timestampMap = new Map();

        items.forEach(item => {
            const measures = item[`${props.which}Measure`] || [];
            measures.forEach(m => {
                if (!m || !m.insertedDate) return;
                const formattedDate = props.dateFormatter(m.insertedDate);
                if (formattedDate && !timestampMap.has(formattedDate)) {
                    timestampMap.set(formattedDate, m.insertedDate);
                }
            });
        });

        const sortedEntries = Array.from(timestampMap.entries()).sort((a, b) => {
            const dateA = props.dateFormatter(a[1]);
            const dateB = props.dateFormatter(b[1]);
            return dateA < dateB ? -1 : (dateA > dateB ? 1 : 0);
        });

        return sortedEntries.map(([dateStr, rawDate]) => ({ dateStr, rawDate }));
    };

    const uniqueTimestamps = getUniqueTimestamps();

    const handleColumnRemove = (n) => {
        const commentsList = props.getValues(`process[${props.nestIndex}][${props.which}Comments`) || [];
        switch (props.which) {
            case 'field':
                fieldRemoveComments(commentsList.length - 1 - n);
                break;
            case 'lab':
                labRemoveComments(commentsList.length - 1 - n);
                break;
            case 'automatic':
                automaticRemoveComments(commentsList.length - 1 - n);
                break;
            default:
                break;
        }
    };

    const handleColumn = (n) => {
        toast.success("測定データが削除されました", {
            position: toast.POSITION.TOP_RIGHT
        });
        setRemoveIndex(null);
    };

    const deleteMeasures = (n) => {
        const tsTarget = uniqueTimestamps[n];
        if (!tsTarget) return;

        const itemsPath = `process[${props.nestIndex}].items`;
        const items = props.getValues(itemsPath) || [];

        const updatedItems = items.map((item) => {
            const measures = item[`${props.which}Measure`] || [];
            const filteredMeasures = measures.filter((m) => {
                if (!m || !m.insertedDate) return false;
                const formattedStr = props.dateFormatter(m.insertedDate);
                if (formattedStr === tsTarget.dateStr) {
                    if (m.id !== undefined) {
                        props.deleteMeasure({
                            which: props.which,
                            processId: m.processId || props.getValues(`process[${props.nestIndex}].id`),
                            itemId: m.itemsId || item.id,
                            id: m.id
                        });
                    }
                    return false;
                }
                return true;
            });

            return {
                ...item,
                [`${props.which}Measure`]: filteredMeasures
            };
        });

        props.setValue(itemsPath, updatedItems);

        const commentsPath = `process[${props.nestIndex}][${props.which}Comments]`;
        const comments = props.getValues(commentsPath) || [];
        const updatedComments = comments.filter((c) => {
            if (!c || !c.insertedDate) return false;
            const formattedStr = props.dateFormatter(c.insertedDate);
            if (formattedStr === tsTarget.dateStr) {
                if (c.id !== undefined) {
                    props.deleteMeasure({
                        which: props.which,
                        processId: props.getValues(`process[${props.nestIndex}].id`),
                        id: c.id
                    });
                }
                return false;
            }
            return true;
        });

        props.setValue(commentsPath, updatedComments);

        toast.success("測定データが削除されました", {
            position: toast.POSITION.TOP_RIGHT
        });
        setDataIndex(prev => !prev);
        setRefresh(prev => !prev);
    };

    fields.sort(compareDatesAsc);

    const handleChange = (e) => {
        setInsertionDate(null);
        setIdx(e === idx ? null : e);
    };

    const dateHandler = (date) => {
        setInsertionDate(date);
    };

    const addValueRows = async (x) => {
        if (!insertionDate) return setIdx(null);

        let fieldComment = await props.db.collection('measurement').doc(props.getValues(`id`)).collection('process').doc(props.getValues(`process[${props.nestIndex}].id`)).collection(`${props.which}Comments`)
            .where("insertedDate", ">=", startAt(insertionDate))
            .where("insertedDate", "<", startAt((new Date(insertionDate)).setMinutes((new Date(insertionDate)).getMinutes() + 1)))
            .limit(1).get();

        props.getValues(`process[${props.nestIndex}].items`).forEach((item, itemIndex) => {
            let itemMeasures = item[`${props.which}Measure`] || [];
            let same = itemMeasures.find((z) => z && z.insertedDate && moment(z.id === undefined ? z.insertedDate : (z.insertedDate.toDate ? z.insertedDate.toDate() : z.insertedDate)).isSame(insertionDate, 'minute'));

            if (fieldComment.docs.length === 0 && same === undefined) {
                props.setValue(
                    `process[${props.nestIndex}].items[${itemIndex}][${props.which}Measure][${x}].insertedDate`,
                    props.getValues(`process[${props.nestIndex}].items[${itemIndex}][${props.which}Measure][${x}].id`) !== undefined
                        ? firebase.firestore.Timestamp.fromDate(insertionDate)
                        : insertionDate
                );
                props.setValue(`process[${props.nestIndex}].items[${itemIndex}][${props.which}Measure][${x}].changed`, true);
            }
        });

        const commentsList = props.getValues(`process[${props.nestIndex}][${props.which}Comments`) || [];
        let sameComment = commentsList.find((z) => z && z.insertedDate && moment(z.id === undefined ? z.insertedDate : (z.insertedDate.toDate ? z.insertedDate.toDate() : z.insertedDate)).isSame(insertionDate, 'minute'));

        if (fieldComment.docs.length === 0 && sameComment === undefined) {
            const targetIdx = commentsList.length - 1 - x;
            if (targetIdx >= 0 && targetIdx < commentsList.length) {
                props.setValue(
                    `process[${props.nestIndex}][${props.which}Comments][${targetIdx}].insertedDate`,
                    props.getValues(`process[${props.nestIndex}][${props.which}Comments][${targetIdx}].id`) !== undefined
                        ? firebase.firestore.Timestamp.fromDate(insertionDate)
                        : insertionDate
                );
                props.setValue(`process[${props.nestIndex}][${props.which}Comments][${targetIdx}].changed`, true);
            }
            setEditIndex({ index: x, insertionDate: insertionDate });
            setRemoveIndex(null);
            setInsertionDate(null);
            setIdx(null);
            setDataIndex(!dataIndex);
            setRefresh(!refresh);
            toast.success("測定データが更新されました", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    };

    const nextReloadDar = async () => {
        if (!props.enabledNext) {
            let data = {};
            data.processId = props.getValues(`process[${props.nestIndex}].id`);
            data.processIndex = props.nestIndex;
            data.which = props.which;
            props.nextData(data);
        }
    };

    return (
        <div className={'measure'}>
            <div className="overflow-auto">
                <div style={{
                    backgroundColor: props.color,
                    margin: '10px 0',
                    padding: '0px',
                    color: '#FFF',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    alignItems: 'center'
                }}>
                    <span style={{ marginLeft: 5 }}>{props.title}</span>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {props.onExcelImport && (
                            <MDBBtn
                                className="form-check form-check-inline"
                                rounded
                                color="white"
                                size={'sm'}
                                style={{ color: props.color, fontWeight: 'bold' }}
                                onClick={() => props.onExcelImport(props.which)}
                            >
                                <MDBIcon icon="file-excel" className="mr-1" />
                                <span style={{ fontSize: 12 }}>Excelインポート</span>
                            </MDBBtn>
                        )}
                        <MDBBtn className="form-check form-check-inline" rounded color="white" size={'sm'} disabled={props.getValues(`process[${props.nestIndex}][${which}NotMore]`)} onClick={() => nextReloadDar()}>
                            <span style={{ fontSize: 12 }}>次の{props.limit}件</span>
                        </MDBBtn>
                    </div>
                </div>

                <MDBTable autoWidth={true}
                    responsive fixed small
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    bordered={true} className="table-fixed w-full"
                >
                    <MDBTableHead style={{ backgroundColor: '#f2f2f2', width: '100%' }}>
                        <tr style={{ justifyContent: 'center', alignItems: 'center', flex: 1, alignContent: 'center' }}>
                            <th style={{
                                textAlign: 'center',
                                minWidth: 100,
                                backgroundColor: '#f2f2f2',
                                position: 'sticky',
                                left: 0,
                                zIndex: 1
                            }}>
                                管理項目
                            </th>
                            <th style={{
                                textAlign: 'center',
                                minWidth: 150,
                                backgroundColor: '#f2f2f2',
                                position: 'sticky',
                                left: 100,
                                zIndex: 1
                            }}>
                                許容範囲
                            </th>
                            {
                                uniqueTimestamps.map((ts, vr_x) => (
                                    <th key={ts.dateStr} style={{ alignItems: 'center', textAlign: 'center' }}>
                                        <span>
                                            {ts.dateStr.substring(5, 10)}<br />
                                            {ts.dateStr.substring(11, 16)}<br />
                                        </span>
                                        {props.editClicked && idx === vr_x && (
                                            <DatePicker id="datePicker1" className={'datePicker'}
                                                selected={insertionDate ? insertionDate : (new Date(moment(ts.rawDate.seconds === undefined ? ts.rawDate : ts.rawDate.toDate()).format('YYYY/MM/DD HH:mm')))}
                                                showTimeInput timeInputLabel="Time:"
                                                dateFormat="yyyy/MM/dd HH:mm" maxDate={new Date()}
                                                onChange={(date) => dateHandler(date)}
                                            />
                                        )}
                                        <div style={{ marginTop: 3 }}>
                                            {props.editClicked && idx === vr_x && (
                                                <MDBIcon style={{ cursor: 'pointer' }} size={'lg'} fas icon="undo"
                                                    onClick={() => handleChange(vr_x)}
                                                />
                                            )}
                                            {props.editClicked && idx === vr_x && (
                                                <MDBIcon style={{ cursor: 'pointer', marginLeft: 5 }} size={'lg'} fas
                                                    icon="save" onClick={() => addValueRows(vr_x)}
                                                />
                                            )}
                                        </div>
                                        <div>
                                            {props.editClicked && idx !== vr_x && (
                                                <MDBIcon style={{ cursor: 'pointer' }} size={'lg'} fas icon="edit"
                                                    onClick={() => handleChange(vr_x)}
                                                />
                                            )}
                                            {props.editClicked && idx !== vr_x && (
                                                <MDBIcon style={{ marginLeft: 5, cursor: 'pointer' }} size={'lg'} fas
                                                    icon="trash" onClick={() => {
                                                        deleteMeasures(vr_x);
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </th>
                                ))
                            }
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        {fields.map((item, item_index) => (
                            <tr key={item_index} style={{ textAlign: 'center', alignItems: 'center' }}>
                                <td style={{
                                    textAlign: 'center',
                                    minWidth: 100,
                                    backgroundColor: '#f2f2f2',
                                    position: 'sticky',
                                    left: 0,
                                    zIndex: 1
                                }}>
                                    {item.item_name}
                                </td>
                                <td style={{
                                    textAlign: 'center',
                                    minWidth: 150,
                                    backgroundColor: '#f2f2f2',
                                    position: 'sticky',
                                    left: 100,
                                    zIndex: 1
                                }}>
                                    {item.tolerance_lvl_min}~{item.tolerance_lvl_max}{item.unit}
                                </td>
                                <MeasurementsItems
                                    reloader={props.reloader}
                                    refresh={refresh}
                                    editIndex={editIndex}
                                    refreshRemoveIndex={dataIndex}
                                    appendItem={props.appendItem}
                                    removeIndex={removeIndex}
                                    editClicked={props.editClicked}
                                    nestIndex={props.nestIndex}
                                    itemIndex={item_index}
                                    uniqueTimestamps={uniqueTimestamps}
                                    {...{ control, register }}
                                    getValues={props.getValues}
                                    setValue={props.setValue}
                                    dateFormatter={props.dateFormatter}
                                    which={props.which}
                                    title={props.title}
                                    color={props.color}
                                    db={props.db}
                                />
                            </tr>
                        ))}
                    </MDBTableBody>
                </MDBTable>
            </div>

            <div style={{ marginBottom: '10px', marginTop: '10px' }} id="accordion">
                <Accordion collapsible={true} multiple={false} defaultSelectedIndex={-1}
                    itemTitleRender={() => {
                        return <div style={{ fontSize: '16px' }}><MDBIcon fas icon="comments" /> &nbsp; コメント</div>
                    }}>
                    <Item title="コメント">
                        {(props.getValues(`process[${props.nestIndex}][${props.which}Comments`) || []).map((cmnt, cmnt_index) => (
                            <div style={{ display: 'flex', alignItems: 'center', margin: '10px 0', paddingLeft: '10px' }}
                                key={cmnt.insertedDate || cmnt_index}
                            >
                                <span style={{ flexGrow: .02 }} onClick={(event => event.target.value = null)}
                                    aria-readonly={true}>{props.dateFormatter(cmnt.insertedDate)}</span>
                                <input key={cmnt.insertedDate || cmnt_index} className={'form-control'} style={{
                                    flex: 1,
                                    backgroundColor: !props.editClicked ? 'white' : (cmnt.edit ? '#FFFDE8' : '')
                                }} readOnly={!props.editClicked}
                                    {...props.register(`process[${props.process_index}][${props.which}Comments][${cmnt_index}].comment`)}
                                    onChange={(e) => {
                                        props.setValue(`process[${props.process_index}][${props.which}Comments][${cmnt_index}]`, {
                                            comment: e.target.value,
                                            edit: cmnt.id === undefined ? false : true,
                                            insertedDate: cmnt.insertedDate,
                                            id: cmnt.id,
                                            changed: true,
                                        });
                                    }}
                                />
                            </div>
                        ))}
                    </Item>
                </Accordion>
            </div>
        </div>
    );
};

export default Measurements;